import { render, staticRenderFns } from "./switch-plus.vue?vue&type=template&id=4308ba7c"
import script from "./switch-plus.vue?vue&type=script&lang=js"
export * from "./switch-plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports